<template>
  <div class="account-page">
    <!-- Main Wrapper -->
    <div class="main-wrapper">
      <div class="account-content">
        <div class="login-wrapper">

          <div class="login-img">
            <img src="../../../assets/img/login.png" alt="img" size="10" />
          </div>
          <div class="login-content">
            <div class="login-userset">
              <div class="login-logo logo-normal">
                <img src="../../../assets/img/logo.png" alt="img" />
              </div>
              <router-link to="/index" class="login-logo logo-white">
                <img src="../../../assets/img/logo-white.png" alt="" />
              </router-link>
              <div class="login-userheading">
                <h3>Enter PIN</h3>
                <h4>Please enter your pin</h4>
              </div>
              <form class="login" @submit.prevent="onSubmit">
                <div class="form-login">
                  <label>Pin</label>
                  <div class="form-addons ">
                    <div class="d-flex gap-2">
                      <div v-for="(field, index) in pinFields" :key="index">
                        <input
                            v-model="pinFields[index]"
                            @input="handleInput(index)"
                            @keydown="handleKeyDown(index, $event)"
                            :maxlength="1"
                            :autofocus="index === 0"
                            type="password"
                            :ref="'pinField' + index"
                            :id="'pin' + (index + 1)"
                          />
                        
                      </div>
                      
                    </div>





                  </div>
                </div>
               
                <div class="form-login">
                  <button class="btn btn-login" type="submit" ref="buttonSignin">Sign In</button>
                  <!-- <router-link class="btn btn-login" to="index"></router-link> -->
                </div>
              </Form>
              <div class="signinform text-center d-flex justify-content-between">
                <div>
                  <router-link to="/" class="hover-a">Change account</router-link>
                </div>
                <div>
                  <h4>
                    Forgotten your PIN?
                    <a @click="sendOtp()" class="hover-a">reset PIN</a>
                  </h4>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Main Wrapper -->
</template>

<script>
import axios from "axios";
import Cookies from "js-cookie";
import { AlertPopup2, base_url, timeout, ErrorConnectionTimeOut, goPage } from "@/assets/js/function";

export default {
  data() {
    return {
      showPassword: false,
      pinFields: ['', '', '', ''],
    };
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },

    handleInput(index) {
      this.pinFields[index] = this.pinFields[index].replace(/[^0-9]/g, '');
      const nextRef = this.$refs['pinField' + (index + 1)];
      if (this.pinFields[index].length === 1 && nextRef && nextRef[0]) {
        nextRef[0].focus();
      }
      if (index == 3) {
        this.onSubmit();
      }
    },

    handleKeyDown(index, event) {
      if (event.key.match(/[^0-9]/) && event.key !== 'Backspace') {
        event.preventDefault();
      } else if (event.key === 'Backspace' && index > 0 && this.pinFields[index] === '') {
        const prevRef = this.$refs['pinField' + (index - 1)];
        if (prevRef && prevRef[0]) {
          prevRef[0].focus();
        }
      }
    },

    async sendOtp() {
      try {
        const phone = localStorage.getItem('phone');
        const formData = new FormData();
        formData.append("phone", phone);

        const api = base_url + 'v3/auth/forgot';
        const res = await axios.post(api, formData, { timeout });
        const data = res.data;

        if (data.status) {
          Cookies.set("token_refresh", data.data.token);
          goPage('confirm-otp');
          AlertPopup2("success", "", "OTP has been sent", false, 1500);
        } else {
          AlertPopup2("error", "", data.message, false, 2000);
        }
      } catch (error) {
        ErrorConnectionTimeOut(error);
      }
    },

    async onSubmit() {
      try {
        const pinFinal = this.pinFields.join('');
        const phone = localStorage.getItem('phone');
        const tipe = localStorage.getItem('tipe_login');

        const formData = new FormData();
        const phoneClean = phone.slice(1).replace(/\s+/g, "")
        formData.set("phone", phoneClean);
        // formData.append("phone", phone);
        formData.append("tipe", tipe);
        formData.append("pin", pinFinal);

      //   for (let [key, value] of formData.entries()) {
      //   console.log(`${key}: ${value}`);
      // }
      // return true

        const api = base_url + 'v3/auth/login';
        const res = await axios.post(api, formData, { timeout });
        const data = res.data;
        console.log('Ini data login :', data)
        if (data.status) {
          Cookies.set("token_refresh", data.data.token_refresh);
          localStorage.setItem('nama_user', data.data.user_fullname);
          localStorage.setItem('tipe_user', data.data.user_type);
          localStorage.setItem('company_type', data.data.company_type);
          localStorage.setItem('company_default', data.data.company_default);
          localStorage.setItem('selectedBranch', data.data.company_default);
          localStorage.setItem('startCutOff', data.data.cut_off.start);
          localStorage.setItem('EndCutOff', data.data.cut_off.end);
          
          localStorage.setItem('company_list', JSON.stringify(data.data.company_list));
        
          const selectedBranchId = data.data.company_default;
          const selectedCompany = data.data.company_list.find(company => company.id === selectedBranchId);
          
          if (selectedCompany) {
            localStorage.setItem('namaCompany', selectedCompany.nama_lokasi); // atau .name tergantung struktur
          }
          localStorage.setItem('actionState', 'view');
          localStorage.removeItem('tipe_login');
          localStorage.removeItem('phone');
          goPage('index');

          this.listBank()
        } else {
          this.pinFields = ['', '', '', ''];
          setTimeout(() => document.getElementById("pin1").focus(), 500);
          AlertPopup2("error", "", data.message, false, 2000);
        }
      } catch (err) {
        ErrorConnectionTimeOut(err);
      }
    },

    async listBank() {
      const formData = new FormData();

      formData.append("token", 'd2afa5fa-c31c-4bf8-932b-c565c14ba1f1');

      for (let [key, value] of formData.entries()) {
          console.log(key, value);
      }
      // return

      const api = base_url + '/v3/flip/banks';
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;
      
      
      // console.log(" History", data);

      if(data.status){

          
          localStorage.setItem('bankList', JSON.stringify(data.data))
          
          
      }else {
          AlertPopup2("error", "", data.message, true, 1500);
      }
    }
  },
};
</script>

